import { ILabels, ILanguage } from "@/apps/StudentExchangePartnerWidget/models/config-viewmodel";

export interface StudentExchangePartnerWidget {
    labels: ILabels
    signup: null | boolean
    insurance: boolean
    privacy: boolean
    programId: number
    redirectUrl: string
    language: ILanguage
    errorMessage: null | string
    studyName: null | string
}

export class WidgetState implements StudentExchangePartnerWidget {
    loading: boolean = false
    signup: null | boolean = null
    insurance: boolean = false
    privacy: boolean = false
    programId: number = 0
    redirectUrl: string = ''
    language: ILanguage = ''
    studyName: null | string = null
    errorMessage: null | string = null
    labels: ILabels = {
        studentExchangeApplicationMainTitle: '',
        studentExchangeEducationTitle: '',
        studentExchangeApplicationTitle: '',
        studentExchangeApplicationQuestion: '',
        studentExchangeApplicationYesLabel: '',
        studentExchangeApplicationNoLabel: '',
        studentExchangeApplicationInformationTitle: '',
        studentExchangeApplicationInformationText: '',
        crisisInsuranceTitle: '',
        crisisInsuranceCheckboxText: '',
        crisisInsuranceInformationTitle: '',
        crisisInsuranceInformationText: '',
        privacyStatementTitle: '',
        privacyStatementCheckboxText: '',
        privacyStatementInformationTitle: '',
        privacyStatementInformationText: '',
        progressBarTitle: '',
        progressBarProgressLabel: '',
        informationSectionTitle: '',
        informationSectionText: '',
        navigateBackButtonLabel: '',
        mobilityOnlineButtonLabel: '',
        mobilityOnlineRequestErrorLabel: '',
        mobilityOnlineReturnUrl: '',
    }
}
